import styled from '@emotion/styled';
import FormControlLabel from '@mui/material/FormControlLabel';

/**
 * A MUI <FormControlLabel> with custom styles
 */
const ExinMuiFormControlLabel = styled(FormControlLabel)`
  font-weight: 600;
  font-size: 0.875rem;
`;

export default ExinMuiFormControlLabel;
